import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import ProductDetails from "./ProductDetails";

class ProductsEdit extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
        this.renderDetails = this.renderDetails.bind(this);

        this.state = {
            product: {},
            details: [],
            successRegister: false
        };
    }

    componentWillMount() {
        let self = this;
        let id = self.props.id_product;

        axios.get('/api/products/details/' + id)
            .then(response => {
                self.setState({
                    product: response.data,
                    details: response.data.details
                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "Ha ocurrido un error al intentar procesar tu solicitud.",
                    icon: "warning",
                });
            });
    }

    componentDidMount()
    {
        let self = this;
        let checkYes = $("#expirationYes");
        let checkNo = $("#expirationNo");
        let inputExp = $('#expiration_date');

        let expiration = parseInt(self.state.product.expiration) === 1;

        if (expiration) {
            checkNo.prop("checked", false);
            checkYes.prop("checked", true);
            inputExp.prop("disabled", false);
        } else {
            $("#expirationNo").prop("checked", true);
            $("#expirationYes").prop("checked", false);
            inputExp.prop("disabled", true);
            inputExp.val("");
        }
    }


    handleChange({target}) {
        let self = this;

        let product = self.state.product;
        product[target.id] = target.value;

        self.setState({
            product: product
        });
    }

    save()
    {
        let self = this;
        let request = self.state.product;

        axios.post('/api/products/update/' + project, request)
            .then(response => {
                location.reload();
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "Ha ocurrido un error al actualizar el producto.",
                    icon: "warning",
                });
            });
    }

    renderDetails(item) {
        let key = Math.random();
        return (
            <div key={key}>
                <ProductDetails details={item}/>
            </div>
        );
    }

    expirationChange(flag)
    {
        let self = this;
        let checkYes = $("#expirationYes");
        let checkNo = $("#expirationNo");
        let inputExp = $('#expiration_date');

        if (!flag) {
            checkNo.prop("checked", false);
            checkYes.prop("checked", true);
            inputExp.prop("disabled", false);

            let product = self.state.product;
            product['expiration'] = 1;
            self.setState({
                product: product
            });

        } else {
            $("#expirationNo").prop("checked", true);
            $("#expirationYes").prop("checked", false);
            inputExp.prop("disabled", true);

            let product = self.state.product;
            product['expiration'] = 0;
            self.setState({
                product: product
            });

        }
    }

    render() {
        this.componentDidMount();
        return (
            <div>
                <div className="col-sm-12">
                    <h4 className="page-title">Editar un producto</h4>
                    <ol className="breadcrumb">
                        <li>
                            <a href="/">Home</a>
                        </li>
                        <li>
                            <a href="/products">Productos</a>
                        </li>
                        <li className="active">
                            Editar
                        </li>
                    </ol>
                </div>

                <div className="row">
                    <div className="col-md-5">
                        <div className="panel panel-default">
                            <div className={"panel-header"}>
                            </div>
                            <div className="panel-body">
                                <div className="col-md-10">
                                    <form role="form" id="productForm">
                                        <div className="form-group">
                                            <label htmlFor="key">Clave</label>
                                            <input type="text" className="form-control" id="key"
                                                   onChange={this.handleChange}
                                                   value={this.state.product.key}/>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="description">Descripción</label>
                                            <textarea className="form-control" id="description"
                                                      onChange={this.handleChange}
                                                      value={this.state.product.description}/>
                                        </div>
                                        <div className="form-group">
                                            <label>¿El producto tiene caducidad?</label>
                                            <div className="checkbox checkbox-danger">
                                                <input type="checkbox" id="expirationYes"
                                                       onChange={this.expirationChange.bind(this, false)} />
                                                <label id="expirationYes">Si</label>
                                            </div>
                                            <div className="checkbox checkbox-info">
                                                <input type="checkbox" id="expirationNo"
                                                       onChange={this.expirationChange.bind(this, true)} />
                                                <label id="expirationNo">No</label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="expiration_date">Caducidad</label>
                                            <input type="date" className="form-control" id="expiration_date"
                                                   onChange={this.handleChange}
                                                   value={this.state.product.expiration_time}/>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="commerce">Comercio</label>
                                            <input type="text" className="form-control" id="commerce"
                                                   onChange={this.handleChange}
                                                   value={this.state.product.commerce}/>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="contact">Contacto</label>
                                            <input typeof="date" className="form-control" id="contact"
                                                   onChange={this.handleChange}
                                                   value={this.state.product.contact}/>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="notes">Notas</label>
                                            <textarea className="form-control" id="notes"
                                                      onChange={this.handleChange}
                                                      value={this.state.product.notes}/>
                                        </div>
                                        <button type="button"
                                                className="btn btn-purple waves-effect waves-light pull-right"
                                                id="productRegisterButton" onClick={this.save}
                                                disabled={!this.state.product.key || !this.state.product.description
                                                || !this.state.product.commerce || !this.state.product.contact}>
                                            <i className="fa fa-save"></i> Guardar
                                        </button>
                                    </form>
                                    {
                                        this.state.successRegister &&
                                        <div>
                                            <a href="/products"
                                               className="btn btn-success waves-effect waves-light pull-right">
                                                <i className="fa fa-arrow-circle-o-left"></i> Regresar a productos
                                            </a>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="panel panel-default">
                            <div className={"panel-header"}>
                            </div>
                            <div className="panel-body">
                                <h4 className="m-t-0 header-title"><b>Lotes de códigos asociados</b></h4>
                                <br/>
                                {
                                    this.state.details.length === 0 &&
                                    <p className="alert alert-warning">
                                        No hay lotes de códigos.
                                    </p>
                                }
                                <div className="col-md-12">
                                    {this.state.details.map(this.renderDetails)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        );
    }
}

export default ProductsEdit;

if (document.getElementById('products_edit-component')) {
    ReactDOM.render(<ProductsEdit id_product={id_product}/>, document.getElementById('products_edit-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/ProductsEdit.jsx